import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["tabindex"]
const _hoisted_2 = ["onClick"]

import { ref, onBeforeUnmount, onMounted } from "vue";
import { UpdateMySelectValue, UpdateValue, select2 } from "./type";
import { useField } from "vee-validate";


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectComponent',
  props: {
    options: {},
    options2: {},
    valueToIndex: { type: Boolean },
    default: {},
    tabindex: {},
    name: {},
    keyOrValue: { type: Boolean },
    isLoading: { type: Boolean },
    size: {},
    bg: {},
    color: {},
    update: { type: Function },
    myValueSelect: {},
    updateMyValueSelect: { type: Function }
  },
  setup(__props: any) {

const props = __props;


const open = ref(false);

const sizeText = ref(
  "text-motserrat-" +
    (props.size ?? 16) +
    ((props?.size ?? 16) < 14 ? "-light" : "")
);
const background = ref(props.bg || "");
const color = ref(props.color || "");

const selected = ref<string | select2>(
  props?.myValueSelect
    ? props?.myValueSelect
    : props?.default
    ? props?.default
    : props?.options2
    ? props?.options2[0]
    : props?.options?.length > 0
    ? props?.options[0]
    : ""
);
const close = () => (open.value = false);

const updateSelect = (updateSelectValue: string) => {
  if (typeof props?.updateMyValueSelect === "function") {
    props?.updateMyValueSelect(updateSelectValue);
  }
  selected.value = updateSelectValue;
};
const { resetField, value } = useField(
  props.name,
  (newValue: string) => newValue
);

const updateValueField = (select: string) => resetField({ value: select });

onBeforeUnmount(() => document.removeEventListener("click", close));

onMounted(() => document.addEventListener("click", close));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["select-form select-search mb-4 b-solid-blue100", [{ 'skeleton-loading-line': props.isLoading }, background.value]]),
    tabindex: _ctx.tabindex,
    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (open.value = !open.value), ["stop"]))
  }, [
    _createElementVNode("p", {
      class: _normalizeClass(["text-raleway-14", [{ open: open.value }, sizeText.value, 'pointer', color.value]])
    }, _toDisplayString(_ctx.$tc(props?.myValueSelect || '') ||
        (_ctx.$tc(_unref(value) || '') ? _ctx.$tc(selected.value.toString()) : _ctx.$tc(props.default)) ||
        _ctx.$tc(props.options[0] || '')), 3),
    _createElementVNode("ul", {
      class: _normalizeClass(["list text-raleway-13", [{ hidden: !open.value }, sizeText.value]]),
      onBlur: close
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options2 ? _ctx.options2 : _ctx.options || [], (option, i) => {
        return (_openBlock(), _createElementBlock("li", {
          class: _normalizeClass([{ 'list-item': true }, sizeText.value]),
          key: i,
          onClick: _withModifiers(($event: any) => {
          updateSelect(
            props.options2
              ? (option as select2).name
              : _ctx.valueToIndex
              ? (i + 1).toString()
              : (option as string)
          );

          updateValueField(
            props.options2
              ? props.keyOrValue
                ? (option as select2)?.id.toString()
                : (option as select2).name
              : props.keyOrValue
              ? `${i + 1}`
              : (option as string)
          );

          close();

          typeof props.update === 'function' &&
            props.update(
              props.options2 ? (option as select2).name : (option as string)
            );
        }, ["stop"])
        }, _toDisplayString((props.options2
            ? _ctx.$tc((option as select2)?.name)
            : _ctx.valueToIndex
            ? i + 1
            : _ctx.$tc((option as string)))), 11, _hoisted_2))
      }), 128))
    ], 34)
  ], 10, _hoisted_1))
}
}

})